import {
  ACTION_ARGS,
  Arg,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import FilterButton from './base.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Quick toggle filter button',
  extends: [
    pick(ACTION_ARGS, [
      { name: 'onSelect', description: 'Action triggered when filter is toggled' },
    ]),
    pick(COMPONENT_STATE_ARGS, ['autofocus', 'disabled']),
    pick(CONTAINER_ARGS, ['fitContent']),
    pick(CONTENT_ARGS, [{ name: 'text', initialValue: 'Quick filter' }]),
  ],
  meta: {
    count: Arg.number({ description: 'Number to display in badge' }).initial(3),
    filtered: Arg.boolean({ description: 'Initial filtered state' }),
  },
  name: 'Quick Filter',
});

export default class SpdsActionButtonFilterQuick extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-button-filter-quick';

  @tracked filtered;

  constructor() {
    super(...arguments);

    this.filtered = this.argOrDefault('filtered');
  }

  get buttonText() {
    if (!this.count) return this.text;

    return [this.text, this.count].join(' ');
  }

  get count() {
    if (isEmpty(this.args.count)) return undefined;

    return `(${this.args.count})`;
  }

  get text() {
    return this.argOrDefault('text');
  }

  handleOnClick = () => {
    this.filtered = !this.filtered;
    this.args.onSelect?.(this.filtered);
  };

  <template>
    <FilterButton
      @autofocus={{@autofocus}}
      @filtered={{this.filtered}}
      @onClick={{this.handleOnClick}}
      class={{this.classes}}
      data-test-spds-action-button-filter-quick
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
      as |FB|
    >
      <FB.Trigger @disabled={{@disabled}} @fitContent={{@fitContent}}>
        {{this.buttonText}}
        {{yield}}
      </FB.Trigger>
    </FilterButton>
  </template>
}

export const ACTION_BUTTON_FILTER_QUICK_METADATA = SpdsActionButtonFilterQuick.metadata;
